import React from "react";
const EditSvg = () => {
  return (
    <svg
      style={{ pointerEvents: "none" }}
      width={17}
      height={17}
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_921_6046)">
        <path
          d="M2.00016 15.9999C1.86091 16.0005 1.72307 15.972 1.59549 15.9162C1.4679 15.8604 1.35336 15.7786 1.25923 15.676C1.16509 15.5733 1.09342 15.4522 1.04881 15.3203C1.00419 15.1884 0.987616 15.0486 1.00016 14.9099L1.37916 10.7399C1.42192 10.2792 1.62506 9.8482 1.95316 9.5219L10.9531 0.521919C11.1239 0.358219 11.3253 0.229789 11.5458 0.143999C11.7663 0.0581991 12.0016 0.0167192 12.2381 0.0219192C12.7711 0.0192492 13.2838 0.226529 13.6651 0.598919L16.4001 3.33692C16.7677 3.68869 16.9813 4.17157 16.9942 4.6802C17.0071 5.18883 16.8184 5.68193 16.4691 6.0519L7.46915 15.0519C7.14325 15.3773 6.71375 15.5782 6.25516 15.6199L2.08516 15.9999C2.06416 15.9989 2.03416 15.9999 2.00016 15.9999ZM12.2721 2.03392L10.3241 3.98392L13.0191 6.6789L14.9671 4.72992L12.2721 2.03392Z"
          fill="#72BCB8"
        />
      </g>
      <defs>
        <clipPath id="clip0_921_6046">
          <rect width={17} height={17} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
const HistorySvg = () => {
  return (
    <svg
      width={15}
      height={15}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.2992 7.5002C14.2972 5.69736 13.5801 3.96895 12.3053 2.69415C11.0305 1.41935 9.30208 0.702258 7.49924 0.700195C6.42508 0.701734 5.3665 0.957221 4.40988 1.44581C3.45327 1.93439 2.62573 2.64224 1.99478 3.51157V1.34761C1.99478 1.17591 1.92657 1.01123 1.80516 0.889819C1.68375 0.768405 1.51907 0.700195 1.34737 0.700195C1.17566 0.700195 1.01099 0.768405 0.889575 0.889819C0.768161 1.01123 0.699951 1.17591 0.699951 1.34761V4.81844C0.699951 5.10024 0.811893 5.37049 1.01115 5.56975C1.21041 5.769 1.48066 5.88094 1.76245 5.88094H5.23328C5.40499 5.88094 5.56966 5.81274 5.69108 5.69132C5.81249 5.56991 5.8807 5.40523 5.8807 5.23353C5.8807 5.06182 5.81249 4.89715 5.69108 4.77574C5.56966 4.65432 5.40499 4.58611 5.23328 4.58611H2.83062C3.32611 3.79448 4.01442 3.14155 4.83108 2.6885C5.64774 2.23544 6.56604 1.99708 7.49995 1.99574C8.95943 1.99742 10.3586 2.578 11.3906 3.61007C12.4225 4.64214 13.0029 6.04143 13.0044 7.5009C13.0027 8.96026 12.4222 10.3594 11.3903 11.3913C10.3584 12.4232 8.95931 13.0037 7.49995 13.0054C6.35618 13.0051 5.24086 12.6488 4.30871 11.986C3.37657 11.3232 2.67382 10.3867 2.29795 9.30645C2.27017 9.22607 2.22681 9.15196 2.17035 9.08837C2.11389 9.02477 2.04544 8.97293 1.96892 8.93583C1.8924 8.89872 1.80931 8.87707 1.72442 8.87211C1.63952 8.86716 1.55448 8.87899 1.47416 8.90695C1.31194 8.96322 1.17873 9.08162 1.10381 9.23611C1.02889 9.39059 1.0184 9.56852 1.07466 9.73074C1.53884 11.065 2.40671 12.2217 3.55791 13.0405C4.7091 13.8593 6.08656 14.2995 7.49924 14.3002C9.30208 14.2981 11.0305 13.581 12.3053 12.3062C13.5801 11.0314 14.2972 9.30303 14.2992 7.5002ZM6.44737 9.66557L7.94974 8.16319C7.99799 8.11491 8.03817 8.05918 8.06874 7.99815C8.112 7.90999 8.1343 7.81302 8.13391 7.71482V3.8877C8.13391 3.71862 8.06674 3.55647 7.94719 3.43691C7.82764 3.31736 7.66548 3.2502 7.49641 3.2502C7.32733 3.2502 7.16518 3.31736 7.04563 3.43691C6.92607 3.55647 6.85891 3.71862 6.85891 3.8877V7.44849L5.54283 8.76386C5.48361 8.82306 5.43663 8.89335 5.40458 8.97071C5.37253 9.04807 5.35603 9.13098 5.35603 9.21472C5.35603 9.29845 5.37253 9.38137 5.40458 9.45872C5.43663 9.53608 5.48361 9.60637 5.54283 9.66557C5.66227 9.78516 5.82431 9.85242 5.99333 9.85257C6.07756 9.85306 6.16106 9.83684 6.23899 9.80487C6.31693 9.77289 6.38775 9.72508 6.44737 9.66557Z"
        fill="white"
      />
    </svg>
  );
};
const DeleteSvg = ({ color }: any) => {
  return (
    <svg
      width={17}
      height={17}
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_921_6579)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.9162 17.0001H4.08406C3.15161 17.0001 2.39209 16.2406 2.39209 15.3082V3.5293H14.6066V15.3082C14.608 16.2406 13.8485 17.0001 12.9161 17.0001H12.9162ZM5.65441 14.6994C5.27948 14.6994 4.97378 14.3937 4.97378 14.0188V5.71523C4.97378 5.3403 5.27948 5.0346 5.65441 5.0346C6.03074 5.0346 6.33504 5.3403 6.33504 5.71523V14.0174C6.33644 14.3937 6.03064 14.6994 5.65441 14.6994ZM8.50016 14.6994C8.12533 14.6994 7.81953 14.3937 7.81953 14.0188V5.71523C7.81953 5.3403 8.12523 5.0346 8.50016 5.0346C8.87649 5.0346 9.18079 5.3403 9.18079 5.71523V14.0174C9.18079 14.3937 8.87639 14.6994 8.50016 14.6994ZM11.3459 14.6994C10.971 14.6994 10.6653 14.3937 10.6653 14.0188V5.71523C10.6653 5.3403 10.971 5.0346 11.3459 5.0346C11.7208 5.0346 12.0265 5.3403 12.0265 5.71523V14.0174C12.0265 14.3937 11.7207 14.6994 11.3458 14.6994H11.3459Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.8724 3.13052H1.12744C1.01678 3.13052 0.928223 3.04197 0.928223 2.9313V1.73738C0.928223 1.53258 1.09567 1.36523 1.30036 1.36523H15.6995C15.9043 1.36523 16.0716 1.53268 16.0716 1.73738V2.9313C16.0716 3.04197 15.9816 3.13052 15.8724 3.13052Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.4296 1.76528H6.56983C6.45916 1.76528 6.37061 1.67673 6.37061 1.56606V0.372142C6.37061 0.167344 6.53805 0 6.74275 0H10.2581C10.4629 0 10.6302 0.167444 10.6302 0.372142V1.56606C10.6288 1.67534 10.5403 1.76528 10.4296 1.76528Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_921_6579">
          <rect width={17} height={17} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
const EyeSvg = () => {
  return (
    <svg
      width={26}
      height={17}
      viewBox="0 0 26 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 0.59375C7.09091 0.59375 2.04455 4.28688 0 9.5C2.04455 14.7131 7.09091 18.4062 13 18.4062C18.9091 18.4062 23.9555 14.7131 26 9.5C23.9555 4.28688 18.9091 0.59375 13 0.59375ZM13 15.4375C9.73818 15.4375 7.09091 12.7775 7.09091 9.5C7.09091 6.2225 9.73818 3.5625 13 3.5625C16.2618 3.5625 18.9091 6.2225 18.9091 9.5C18.9091 12.7775 16.2618 15.4375 13 15.4375ZM13 5.9375C11.0382 5.9375 9.45455 7.52875 9.45455 9.5C9.45455 11.4712 11.0382 13.0625 13 13.0625C14.9618 13.0625 16.5455 11.4712 16.5455 9.5C16.5455 7.52875 14.9618 5.9375 13 5.9375Z"
        fill="#72BCB8"
      />
    </svg>
  );
};
export { EditSvg, DeleteSvg, EyeSvg, HistorySvg };
